var _defs, _circle, _path, _circle2, _path2, _path3, _path4, _g, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBZ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7941f;}.cls-2{fill:#fffffe;}.cls-3{fill:#29317d;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:#fdb71d;}.cls-7{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1434.2,
    y1: 492.22,
    x2: -1433.81,
    y2: 492.22,
    gradientTransform: "matrix(20.41, 0, 0, -26.72, 29289.06, 13172.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7671b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#be9fcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#d7b0d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#726ab0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#4151a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#6b65ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#d7b0d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#6dcde5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1211.17,
    y1: 481.8,
    x2: -1210.78,
    y2: 481.8,
    gradientTransform: "matrix(5.09, 0, 0, -13.3, 6181.12, 6431.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7671b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#65bae8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#6dcde5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#d7b0d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#4151a3"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.83,
    cy: 12.36,
    r: 8.83
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.73,12.68a2.85,2.85,0,0,1,.41.26,1.55,1.55,0,0,1,.56.83,1.61,1.61,0,0,1,0,.62,2.89,2.89,0,0,1-.38,1.1,1.84,1.84,0,0,1-1.25.85,3.73,3.73,0,0,1-1,0,7.68,7.68,0,0,1-.82-.11s0,0,0,0l-.36,1.45c0,.07,0,.08-.09.06L8,17.6s0,0,0-.05c.12-.48.24-1,.37-1.46,0,0,0-.05,0-.07l-.67-.17s0,0,0,0l-.36,1.48s0,0-.06,0l-.86-.21s0,0,0-.06c.12-.5.25-1,.37-1.49,0,0,0,0,0-.05l-1.83-.46s0,0,0,0l.44-1s0,0,0,0l.62.16.16,0A.35.35,0,0,0,6.29,14l.6-2.42c.15-.58.29-1.17.44-1.75a.48.48,0,0,0-.27-.57,3.06,3.06,0,0,0-.43-.13L6.26,9s0,0,0-.05c.08-.31.15-.62.23-.94,0,0,0,0,0,0l1.22.31.61.15s0,0,.05,0L8.75,7a0,0,0,0,0,0,0s0,0,0,0l.9.22s0,0,0,0l-.24.95c0,.17-.08.33-.13.49s0,.05,0,.05l.68.16s0,0,0,0l.36-1.43s0,0,0,0l.86.21s.05,0,0,.06c-.12.49-.24,1-.37,1.46,0,0,0,0,0,.07a4.77,4.77,0,0,1,.95.43,2.09,2.09,0,0,1,.67.62,1.46,1.46,0,0,1,.25.93,2.14,2.14,0,0,1-.2.79,1.42,1.42,0,0,1-1,.76l0,0ZM9.59,15a2,2,0,0,0,.58-.08.88.88,0,0,0,.59-1.09,1.06,1.06,0,0,0-.4-.53,3.12,3.12,0,0,0-.82-.4,11.43,11.43,0,0,0-1.15-.3s0,0,0,0c-.17.67-.33,1.34-.5,2,0,0,0,.05,0,.05.27.07.54.15.81.2A5.28,5.28,0,0,0,9.59,15Zm.42-3.1a1.65,1.65,0,0,0,.44-.05.83.83,0,0,0,.62-1,.89.89,0,0,0-.34-.53,2.88,2.88,0,0,0-.68-.34c-.3-.1-.63-.17-.94-.24,0,0,0,0,0,0l-.45,1.82s0,0,0,0l.42.11A3.83,3.83,0,0,0,10,11.92Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    className: "cls-3",
    cx: 21.17,
    cy: 18.6,
    r: 8.83
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-4",
    d: "M23.4,20.05l2.13,3.77h-2l-3-5.27h1.55a1.65,1.65,0,0,0,1.21-.51,1.68,1.68,0,0,0,.52-1.25,1.61,1.61,0,0,0-.52-1.22,1.65,1.65,0,0,0-1.21-.51c-.95,0-2.09.06-2.75.08-.16,0-.44,0-.79,0l-1-1.83,4.56,0a3.47,3.47,0,0,1,3.46,3.49,3.55,3.55,0,0,1-2.13,3.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-5",
    d: "M19.48,22.17v1.64h-2c0-1.74,0-3.48,0-5.23h.11l.13.43a25.21,25.21,0,0,0,1.76,3.16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-6",
    d: "M19.46,15.14h0v0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-7",
    d: "M23.51,20.08l2.13,3.73h-2l-3-5.22h1.55a1.76,1.76,0,0,0,1.73-1.74,1.59,1.59,0,0,0-.52-1.21,1.65,1.65,0,0,0-1.21-.51l-3.59,0-1-1.75,4.56,0a3.48,3.48,0,0,1,3.47,3.47,3.34,3.34,0,0,1-.62,2,3.38,3.38,0,0,1-1.52,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-7",
    d: "M19.59,22.17v1.64h-2c0-1.74,0-3.49,0-5.23l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-7",
    d: "M19.57,15.14h0v0Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-6",
    d: "M19.36,15.13h0v0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBZ);
export default __webpack_public_path__ + "static/media/B-Z.7fda3a52c723cb1ae04d7421f0810db8.svg";
export { ForwardRef as ReactComponent };